import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { setSelectedDegreesAndDepartmentsList } from '../../action'
import { SectionWrapper, TopFlex, TopHeader } from '../../Style/style'
import RuleHeader from '../RuleHeader'
import RuleSetCourses from './RuleSetCourses'

export default function SettingNewRules({
  getEligibilityCriteria,
  createRules,
  getInstituteRulesById,
  setUpNewRules,
  checkRuleSet,
  rulesDegreesMetrics,
  updateRules,
  selectedDegStreamList,
  ruleOverwrite,
}) {
  const params = useParams()
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const [selectedSearchType, setSelectedSearchType] = useState('DEGREE')
  const [rulesDetails, setRulesDetails] = useState({})
  const [degreeStreamList, setDegreeStreamList] = useState([])
  const [selectedStreamList, setSelectedStreamList] = useState([])
  const [alreadySetDegreeList, setAlreadySetDegreeList] = useState([])
  const [isDegreeStreamLoading, setIsDegreeStreamLoading] = useState(false)
  const [criteriaTypes, setCriteriaTypes] = useState([])
  const fetchDegreeAndDepartment = async ({
    checkList = alreadySetDegreeList,
    type = criteriaTypes[0] || '',
    search = '',
    searchType = selectedSearchType,
  }) => {
    const keyword = type === 'DIPLOMA' ? ['DIPLOMA', 'P_G_DIPLOMA'] : [type]
    setIsDegreeStreamLoading(true)
    const response = await getEligibilityCriteria({
      searchValue: search,
      searchType: searchType,
      searchField: keyword,
    })
    setIsDegreeStreamLoading(false)
    if (response?.length > 0) {
      const list = response?.map(degree => {
        const department = degree.streams?.map(stream => {
          const matchingCheckListItem = checkList?.find(
            c =>
              c.degreeId === degree.degreeId && c.streamId === stream.streamId
          )
          return {
            ...stream,
            streamName: stream?.streamName?.toLowerCase(),
            isExistingRule: matchingCheckListItem?.isExistingRule || false,
            isDraft: matchingCheckListItem?.isDraft || false,
            isSelected: matchingCheckListItem?.isSelected || false,
          }
        })

        const isSelectAllDegree = department?.every(d => d?.isSelected)
        return {
          ...degree,
          isSelected: isSelectAllDegree,
          streams: department,
        }
      })

      setDegreeStreamList(list)
      return list
    } else {
      setDegreeStreamList([])
      return []
    }
  }

  const fetchAlreadySetDegreeList = async ({
    search = '',
    type = criteriaTypes[0] || '',
    searchType = selectedSearchType,
  }) => {
    const response = await checkRuleSet(params.ruleId)
    const alreadySetList = response?.map(item => ({
      degreeId: item.degree?.id,
      streamId: item.stream?.id,
      isSelected: false,
      isExistingRule: item?.status === 1,
      isDraft: item?.status === 0,
    }))

    let selectedList = []
    if (params?.ruleId) {
      setLoading(true)
      const instituteResponse = await getInstituteRulesById(params.ruleId)
      setLoading(false)
      setRulesDetails(instituteResponse)
      selectedList =
        instituteResponse?.degreeStreamMapId?.map(item => {
          const existingItem = alreadySetList?.find(
            i =>
              i.degreeId === item.degree?.id && i.streamId === item.stream?.id
          )
          if (existingItem) {
            return {
              degreeId: item.degree?.id,
              streamId: item.stream?.id,
              isSelected: true,
              isExistingRule: existingItem.isExistingRule, // Get from alreadySetDegreeList
              isDraft: existingItem.isDraft, // Get from alreadySetDegreeList
            }
          } else {
            return {
              degreeId: item.degree?.id,
              streamId: item.stream?.id,
              isSelected: true,
              isExistingRule: false, // Default value
              isDraft: false, // Default value
            }
          }
        }) || []
    }

    const removedListFromSelectedList = alreadySetList.filter(item => {
      return !selectedList.some(
        s => s.degreeId === item.degreeId && s.streamId === item.streamId
      )
    })

    const mergedList = [
      ...(removedListFromSelectedList || []),
      ...(selectedList || []),
    ]

    let removedList = []
    if (selectedDegStreamList?.check) {
      let data = selectedDegStreamList?.list?.map(item => ({
        degreeId: item.degree?.id,
        streamId: item.stream?.id,
        isSelected: false,
      }))
      removedList = mergedList?.map(item => {
        if (
          data?.some(
            r => r.degreeId === item.degreeId && r.streamId === item.streamId
          )
        ) {
          return {
            ...item,
            isSelected: false,
          }
        } else {
          return item // Ensure we return the item if the condition is not met
        }
      })

      dispatch(
        setSelectedDegreesAndDepartmentsList({
          check: false,
          list: [],
        })
      )
    }
    const finalList = selectedDegStreamList?.check ? removedList : mergedList
    setAlreadySetDegreeList(finalList)
    await fetchDegreeAndDepartment({
      checkList: finalList,
      search,
      type,
      searchType,
    })
  }

  useEffect(() => {
    setUpNewRules()
    if (criteriaTypes?.length > 0) {
      fetchAlreadySetDegreeList({})
    }
  }, [params, params?.ruleId, criteriaTypes])

  const fetchTypes = async () => {
    const response = await getEligibilityCriteria({
      searchValue: '',
      searchType: 'ALL',
      searchField: [],
    })
    if (Array.isArray(response)) {
      const typesArray = [...new Set(response.map(item => item.type))]
      const customOrder = [
        'UG',
        'PG',
        'DIPLOMA',
        'P.G.DIPLOMA',
        'P_G_DIPLOMA',
        'PHD',
      ]
      const sortedQualifications =
        typesArray?.length === 0
          ? []
          : typesArray?.sort(
              (a, b) => customOrder?.indexOf(a) - customOrder?.indexOf(b)
            )
      setCriteriaTypes(sortedQualifications)
    }
  }

  useEffect(() => {
    fetchTypes()
  }, [])

  return (
    <SectionWrapper>
      <TopHeader row spaceBetween alignCenter>
        <TopFlex column>
          <RuleHeader cardData={rulesDegreesMetrics} />
          <RuleSetCourses
            degreeStreamList={degreeStreamList}
            criteriaCall={fetchDegreeAndDepartment}
            setSelectedStreamList={setSelectedStreamList}
            selectedStreamList={selectedStreamList}
            createRules={createRules}
            setSelectedSearchType={setSelectedSearchType}
            selectedSearchType={selectedSearchType}
            alreadySetDegreeList={alreadySetDegreeList}
            setAlreadySetDegreeList={setAlreadySetDegreeList}
            ruleId={params.ruleId}
            updateRules={updateRules}
            getInstituteRulesById={getInstituteRulesById}
            isDegreeStreamLoading={isDegreeStreamLoading}
            ruleOverwrite={ruleOverwrite}
            rulesDetails={rulesDetails}
            criteriaTypes={criteriaTypes}
            loading={loading}
          />
        </TopFlex>
      </TopHeader>
    </SectionWrapper>
  )
}
